import { Modal, Form, DatePicker, InputNumber } from "antd";
import { useEffect, useState } from "react";
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
import { useNavigate } from "react-router-dom";
import { formStyle2, layout } from "../styles";
import { usePagamentoProp } from "../hooks/usePagamentoProp";

interface ModalConfirmarProps {
  isModalOpen: boolean;
  handleFechar: () => void;
  reservaId: null | number;
}

export default function ModalPagamentoProp({
  isModalOpen,
  handleFechar,
  reservaId,
}: ModalConfirmarProps) {
  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Erro
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  const [pagamentoProp, setPagamentoProp] = useState("");

  const pagamentoOnChange = (changedValues: Partial<any>, allValues: any) => {
    setPagamentoProp(allValues);
  };

  const { atualizar, errorMessage, successMessage, isLoading, resetError } =
    usePagamentoProp(reservaId, pagamentoProp);

  // Funçao navigate que é utilizada para o reload da página
  const navigate = useNavigate();

  useEffect(() => {
    if (successMessage && !successDisplayed) {
      showSuccess(successMessage);
      setSuccessDisplayed(true);
      setTimeout(() => {
        navigate(0); // Simula um refresh completo
      }, 3000);
    }

    if (errorMessage && !errorDisplayed) {
      showError(errorMessage);
      setErrorDisplayed(true);

      setTimeout(() => {
        resetError();
        setErrorDisplayed(false);
      }, 2000);
    }
  }, [
    errorMessage,
    showError,
    errorDisplayed,
    successMessage,
    showSuccess,
    successDisplayed,
    navigate,
    resetError,
  ]);

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      title="Pagamento Proprietário"
      cancelText="Cancelar"
      okText="Confirmar"
      confirmLoading={isLoading}
      okButtonProps={{
        style: {
          backgroundColor: "#003644",
          borderColor: "#003644",
          color: "white",
        },
      }}
      cancelButtonProps={{
        style: {
          backgroundColor: "#f44336",
          borderColor: "#f44336",
          color: "white",
        },
      }}
      onOk={() => {
        atualizar();
      }}
    >
      <>
        <>{errorContextHolder}</>
        <>{successContextHolder}</>

        <Form
          {...layout}
          onValuesChange={(changedValues, allValues) =>
            pagamentoOnChange(changedValues, allValues)
          }
          name="reserva-pagamento-prop"
          style={formStyle2}
        >
          <Form.Item
            name={["valorPagamentoProp"]}
            label="Valor Proprietário"
            rules={[{ required: true }]}
            className="formItems"
          >
            <InputNumber
              placeholder="Digite o valor proprietário"
              decimalSeparator=","
              formatter={(value) => {
                if (value === undefined || value === null) return "";
                return `R$ ${Number(value).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`;
              }}
              parser={(value) => {
                if (!value) return "";
                const onlyNumbers = value.replace(/\D+/g, ""); // Remove tudo que não for número
                const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(2); // Converte para decimal
                return isNaN(Number(parsedValue)) ? "" : parsedValue;
              }}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            name={["dataPagamentoProprietario"]}
            label="Data Pagamento "
            className="formItems"
          >
            <DatePicker placeholder="Selecione a data" format="DD/MM/YYYY" />
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
}
